import { Injectable } from '@angular/core';
import { SessionStorageService } from 'ngx-webstorage';

@Injectable({
  providedIn: 'root'
})
export class AuthTokenService {

  constructor(private sessionStorage:SessionStorageService) { }

  // JWT common operation performed in this service.
  storeTokenToLocal(token:any){
    this.sessionStorage.store('JWTToken',token);
  }

  removeTokenFromLocal(){
     this.sessionStorage.clear('JWTToken');
  }

  getTokenFromLocal(){
    return this.sessionStorage.retrieve('JWTToken');
  }
}
